import React, { Component } from "react"
import PropTypes from "prop-types"
import Icon from "../icon-v2"
import NavGroup from "./NavGroup"
import Components from ".."
import linkHandler from "../../helpers/storyblokLinkHandler"
import {
  StyledLink,
  StyledDash,
  StyledLinkContent,
  StyledHoverLogo,
} from "./partials/StyledLink"
import ButtonV2 from "../button-v2"

class Link extends Component {
  state = {
    activePage: false,
  }
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.url = linkHandler(this.props.url)
  }
  componentDidMount() {
    if (this.props.path === this.url) {
      this.setState({
        activePage: true,
      })
    }
  }
  handleClick() {
    this.props.onClickHandler()
  }
  render() {
    return (
      <StyledLink
        pageNavProgram={this.props.pageNavProgram}
        activePage={this.state.activePage}
        href={this.url}
        target={this.props.target || "_self"}
      >
        {this.props.dash && <StyledDash>-</StyledDash>}
        {this.props.label}
        <StyledLinkContent>
          {this.props.icon && <img src={this.props.icon.filename} />}
          {this.props.hover_icon && (
            <StyledHoverLogo src={this.props.hover_icon.filename} />
          )}
        </StyledLinkContent>
      </StyledLink>
    )
  }
}

export default Link
